module.exports = __webpack_public_path__ + "img/1505943008.2bfe4d3b.jpg";